// Mock data for Uzman Veteriner Kliniği

export const clinicInfo = {
  name: "Uzman Veteriner Kliniği",
  tagline: "1990'dan Beri Kocaeli'nde",
  phone: "+90 505 723 64 12",
  whatsapp: "+905057236412",
  email: "info@uzmanklinik.com",
  address: "Yenişehir, Demokrasi Cd. No:58, 41050 İzmit/Kocaeli",
  workingHours: "Pazartesi - Cumartesi: 09:00 - 19:00",
  rating: 4.7,
  totalReviews: 234,
  mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.1234567890!2d29.9219!3d40.7658!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDQ1JzU2LjkiTiAyOcKwNTUnMTguOCJF!5e0!3m2!1str!2str!4v1234567890"
};

export const services = [
  {
    id: 1,
    title: "Cerrahi İşlemler",
    description: "Deneyimli cerrahlarımız, modern ekipmanlarla güvenli ameliyatlar gerçekleştirir.",
    icon: "Scissors",
    image: "https://images.unsplash.com/photo-1770836037326-d2df574278b3"
  },
  {
    id: 2,
    title: "İç Hastalıklar",
    description: "Evcil hayvanlarınızın iç hastalıklarının teşhis ve tedavisinde uzmanız.",
    icon: "Stethoscope",
    image: "https://images.unsplash.com/photo-1631815587646-b85a1bb027e1"
  },
  {
    id: 3,
    title: "Dermatoloji",
    description: "Cilt hastalıkları, alerjiler ve deri problemlerinde özel tedavi.",
    icon: "Heart",
    image: "https://images.unsplash.com/photo-1638202993928-7267aad84c31"
  },
  {
    id: 4,
    title: "Aşılama",
    description: "Düzenli aşılama programları ile evcil dostlarınızı koruyoruz.",
    icon: "Syringe",
    image: "https://images.unsplash.com/photo-1725859189289-a48cca8ad6af"
  },
  {
    id: 5,
    title: "Laboratuvar",
    description: "İleri teknoloji laboratuvar test ve analizleri.",
    icon: "FlaskConical",
    image: "https://images.unsplash.com/photo-1551076805-e1869033e561"
  },
  {
    id: 6,
    title: "Ultrason & Röntgen",
    description: "Modern görüntüleme sistemleri ile kesin teşhis.",
    icon: "ScanLine",
    image: "https://images.unsplash.com/photo-1516549655169-df83a0774514"
  }
];

export const reviews = [
  {
    id: 1,
    name: "Ayşe Yılmaz",
    rating: 5,
    date: "2 hafta önce",
    text: "Köpeğim ameliyat oldu ve her şey mükemmel geçti. Doktorlar çok ilgili ve profesyonel. Teşekkür ederiz!",
    avatar: "AY"
  },
  {
    id: 2,
    name: "Mehmet Kaya",
    rating: 5,
    date: "1 ay önce",
    text: "Muhabbet kuşum için geldik. Çok temiz ve modern bir klinik. Veteriner hekimimiz çok bilgiliydi.",
    avatar: "MK"
  },
  {
    id: 3,
    name: "Zeynep Demir",
    rating: 5,
    date: "3 hafta önce",
    text: "1990'dan beri hizmet veren güvenilir bir klinik. Kedimin tedavisi harika geçti. Herkese tavsiye ederim.",
    avatar: "ZD"
  },
  {
    id: 4,
    name: "Can Öztürk",
    rating: 4,
    date: "1 hafta önce",
    text: "Acil durumda gittik, hızlı ve etkili müdahale edildi. Teşekkürler Uzman Veteriner Kliniği!",
    avatar: "CÖ"
  },
  {
    id: 5,
    name: "Elif Şahin",
    rating: 5,
    date: "2 ay önce",
    text: "Köpeğimin cilt hastalığı için geldik. Dermatoloji konusunda gerçekten uzmanlar. Çok memnun kaldık.",
    avatar: "EŞ"
  },
  {
    id: 6,
    name: "Ahmet Yıldız",
    rating: 5,
    date: "3 gün önce",
    text: "Modern ekipman ve deneyimli kadro. Fiyatlar da makul. Kesinlikle tavsiye ediyorum.",
    avatar: "AY"
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Dr. Veteriner Ahmet Çelik",
    title: "Başhekim - Cerrahi Uzmanı",
    experience: "25+ yıl deneyim",
    image: "https://images.unsplash.com/photo-1654895716780-b4664497420d"
  },
  {
    id: 2,
    name: "Dr. Veteriner Aylin Kara",
    title: "İç Hastalıklar Uzmanı",
    experience: "15+ yıl deneyim",
    image: "https://images.unsplash.com/photo-1638202993928-7267aad84c31"
  },
  {
    id: 3,
    name: "Dr. Veteriner Murat Yılmaz",
    title: "Dermatoloji Uzmanı",
    experience: "12+ yıl deneyim",
    image: "https://images.unsplash.com/photo-1631815587646-b85a1bb027e1"
  }
];

export const facilities = [
  "Açık Otopark",
  "Kapalı Otopark",
  "Vale Hizmeti",
  "Asansör",
  "Kafeterya",
  "Nakit Ödeme",
  "Kredi Kartı",
  "Tercüman Hizmeti"
];

export const blogPosts = [
  {
    id: 1,
    title: "Köpeklerde Aşı Takvimi",
    excerpt: "Köpeklerinizin sağlıklı kalması için düzenli aşı programı çok önemlidir. İşte aşı takvimi...",
    date: "15 Aralık 2024",
    image: "https://images.unsplash.com/photo-1537204696486-967f1b7198c8",
    category: "Sağlık"
  },
  {
    id: 2,
    title: "Kuşlarda Beslenme",
    excerpt: "Evcil kuşlarınız için doğru beslenme rehberi. Hangi besinler yararlı, hangilerinden kaçınmalı?",
    date: "10 Aralık 2024",
    image: "https://images.unsplash.com/photo-1552728089-57bdde30beb3",
    category: "Beslenme"
  },
  {
    id: 3,
    title: "Cilt Hastalıklarından Korunma",
    excerpt: "Evcil dostlarınızda cilt problemlerini önlemek için alabileceğiniz önlemler.",
    date: "5 Aralık 2024",
    image: "https://images.unsplash.com/photo-1534361960057-19889db9621e",
    category: "Bakım"
  }
];

export const timeSlots = [
  "09:00", "09:30", "10:00", "10:30", "11:00", "11:30",
  "13:00", "13:30", "14:00", "14:30", "15:00", "15:30",
  "16:00", "16:30", "17:00", "17:30", "18:00", "18:30"
];

export const aboutContent = {
  history: "Kliniğimiz 1990 yılından beri Kocaeli'nde hizmet vermektedir. Evcil dostlarınızın sağlıklı ve mutlu bir yaşam sürmesi için gerekli tüm tıbbi hizmetleri sunmaktayız.",
  mission: "Misyonumuz, evcil hayvanların sağlığını korumak ve iyileştirmek için en yüksek kalitede veteriner hizmeti sunmaktır.",
  vision: "Vizyonumuz, Türkiye'nin en güvenilir ve modern veteriner klinikleri arasında yer almaktır.",
  stats: [
    { label: "Yıllık Deneyim", value: "35+" },
    { label: "Mutlu Müşteri", value: "10,000+" },
    { label: "Başarılı Ameliyat", value: "5,000+" },
    { label: "Memnuniyet Oranı", value: "%95+" }
  ]
};
